import * as PopoverPrimitive from "@radix-ui/react-popover";
import type * as React from "react";

/**
 * KNOWN ISSUE:
 * We need to make sure we keep the Radix popover and dialog package versions in sync,
 * otherwise we will have issues with using the popover within a dialog. See the following
 * GitHub issues for more context:
 *  - https://github.com/radix-ui/primitives/discussions/1748
 *  - https://github.com/radix-ui/primitives/issues/2121
 *  - https://github.com/radix-ui/primitives/issues/1088#issuecomment-2720144489
 */

import { cn } from "../utils";

const Popover = PopoverPrimitive.Root;

const PopoverTrigger = PopoverPrimitive.Trigger;

function PopoverContent({
  className,
  align = "center",
  sideOffset = 4,
  container,
  ...props
}: React.ComponentProps<typeof PopoverPrimitive.Content> & {
  container?: HTMLDivElement | null;
}) {
  return (
    <PopoverPrimitive.Portal container={container}>
      <PopoverPrimitive.Content
        align={align}
        sideOffset={sideOffset}
        className={cn(
          `
            z-50 w-52 rounded-md bg-popover outline outline-background-contrast p-4 text-popover-foreground shadow-md
            data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2
          `,
          className
        )}
        {...props}
      />
    </PopoverPrimitive.Portal>
  );
}

const PopoverAnchor = PopoverPrimitive.Anchor;

export { Popover, PopoverAnchor, PopoverContent, PopoverTrigger };
